
import ToastPlugin from 'vux/src/plugins/toast/index.js'

import Vue from 'vue';
Vue.use(ToastPlugin)

function chinamobile(value){
return{
valid: /^1[3456789]\d{9}$/.test(value),
msg: '手机号码格式不正确！'
}
}
function SFZnumber(value){

return{
valid: /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X)$)/.test(value),
msg: '身份证号码格式不正确！'
}
}
function isVehicleNumber(vehicleNumber) {
var creg="/[京津冀晋蒙辽吉黑沪苏浙皖闽赣鲁豫鄂湘粤桂琼川贵云渝藏陕甘青宁新]{1}[A-Z]{1}[DF]{1}[0-9a-zA-Z]{5}$/u";
var xreg=/^[京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领A-Z]{1}[A-Z]{1}(([0-9]{5}[DF]$)|([DF][A-HJ-NP-Z0-9][0-9]{4}$))/;
/*
var creg=/^[京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领A-Z]{1}[A-Z]{1}[A-HJ-NP-Z0-9]{4}[A-HJ-NP-Z0-9挂学警港澳]{1}$/;
*/
if(vehicleNumber.length == 7){
return creg.test(vehicleNumber);
} else if(vehicleNumber.length == 8){
console.log(xreg.test('粤BAB7216'),555555)
return xreg.test(vehicleNumber);
} else{
return false;
}
};
function SFZValid(code){
var city={11:"北京",12:"天津",13:"河北",14:"山西",15:"内蒙古",21:"辽宁",22:"吉林",23:"黑龙江 ",31:"上海",32:"江苏",33:"浙江",34:"安徽",35:"福建",36:"江西",37:"山东",41:"河南",42:"湖北 ",43:"湖南",44:"广东",45:"广西",46:"海南",50:"重庆",51:"四川",52:"贵州",53:"云南",54:"西藏 ",61:"陕西",62:"甘肃",63:"青海",64:"宁夏",65:"新疆",71:"台湾",81:"香港",82:"澳门",91:"国外 "};
var row = true;
if(!code || !/^\d{6}(18|19|20)?\d{2}(0[1-9]|1[012])(0[1-9]|[12]\d|3[01])\d{3}(\d|[X])$/.test(code)){
row=false;
Vue.$vux.toast.text('证件号码有误');
}else if(!city[code.substr(0,2)]){
row=false;
Vue.$vux.toast.text('证件号码有误,地址编码错误');
}else{

if(code.length == 18){
code = code.split('');
var factor = [ 7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2 ];

var parity = [ 1, 0, 'X', 9, 8, 7, 6, 5, 4, 3, 2 ];
var sum = 0;
var ai = 0;
var wi = 0;
for (var i = 0; i < 17; i++)
{
ai = code[i];
wi = factor[i];
sum += ai * wi;
}
if(parity[sum % 11] != code[17].toUpperCase()){
row=false;
Vue.$vux.toast.text('证件号码有误,校验位错误')
}
}
}
return row;
};

export {chinamobile,SFZnumber,isVehicleNumber,SFZValid}



// WEBPACK FOOTER //
// ./src/api/validate.js